var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"flex-row flex__right"},[_vm._v("\n  "+_vm._s(_vm.props.name || "-")+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34de37c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/displayPeople.vue
// module id = null
// module chunks = 